var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-bbox": "67 83 378 288.01",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    "data-type": "color",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M85.62 307.5c-7.23 0-13.12-5.88-13.12-13.12V101.62c0-7.23 5.88-13.12 13.12-13.12h340.77c7.23 0 13.12 5.88 13.12 13.12v192.77c0 7.23-5.88 13.12-13.12 13.12H85.62z",
    fill: "#ffffff",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.38 94c4.2 0 7.62 3.42 7.62 7.62v192.76c0 4.2-3.42 7.62-7.62 7.62H85.62c-4.2 0-7.62-3.42-7.62-7.62V101.62c0-4.2 3.42-7.62 7.62-7.62h340.76m0-11H85.62C75.34 83 67 91.34 67 101.62v192.76C67 304.66 75.34 313 85.62 313h340.76c10.28 0 18.62-8.34 18.62-18.62V101.62C445 91.34 436.66 83 426.38 83z",
    fill: "#ff0000",
    "data-color": 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445 346.18v17.65a7.18 7.18 0 0 1-7.18 7.18H74.18a7.18 7.18 0 0 1-7.18-7.18v-17.65a7.18 7.18 0 0 1 7.18-7.18h159.65a7.18 7.18 0 0 0 7.18-7.18v-9.65a7.18 7.18 0 0 1 7.18-7.18h15.65a7.18 7.18 0 0 1 7.18 7.18v9.65a7.18 7.18 0 0 0 7.18 7.18h159.65c3.94 0 7.15 3.21 7.15 7.18z",
    fill: "#ff0000",
    "data-color": 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPc);
export default __webpack_public_path__ + "static/media/pc.5aa4cf2018988996446e40d059273d82.svg";
export { ForwardRef as ReactComponent };